import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { moduleIcon } from '../../modules';

// Placeholder shown for modules that are not built yet.
export default function ModuleStub({ moduleKey }: { moduleKey: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--bg-app)' }}>
      <header style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px', borderBottom: '1px solid var(--border)', background: 'var(--bg-surface)' }}>
        <button onClick={() => navigate('/')} title="SLF" style={{ width: 30, height: 30, padding: 0, border: 'none', background: 'transparent', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><img className="app-logo" src="/logo.png" alt="SLF" style={{ width: 28, height: 28, objectFit: 'contain' }} /></button>
        <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-primary)' }}>{t(`mod_${moduleKey}`)}</div>
      </header>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24 }}>
        <div style={{ width: 76, height: 76, borderRadius: 20, background: 'var(--bg-active)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent)' }}>
          <i className={`ti ti-${moduleIcon(moduleKey)}`} style={{ fontSize: 36 }} aria-hidden />
        </div>
        <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-primary)' }}>{t(`mod_${moduleKey}`)}</div>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--text-tertiary)', background: 'var(--bg-surface)', border: '1px solid var(--border)', padding: '8px 14px', borderRadius: 999 }}>
          <i className="ti ti-tools" style={{ fontSize: 14 }} aria-hidden />
          {t('under_development')}
        </div>
      </div>
    </div>
  );
}
